import { create } from "zustand";
import { persist } from "zustand/middleware";
import type {
  FundRequestPayoutMethod,
  FundRequestPayoutInput,
  GenerateFundRequestLinkResult,
} from "../api/fund-request";

/**
 * The composed money request, captured on TransferPage confirm. Persisted so
 * MintingPage can read the draft and mint the fund-request link.
 */
export interface IRequestDraft {
  sourceCountry: string;
  destinationCountry: string;
  sourceCurrency: string;
  destinationCurrency: string;
  /** Amount the requester wants to receive, in the destination currency. */
  amount: number;
  payoutMethod: FundRequestPayoutMethod;
  payout: FundRequestPayoutInput;
  /** SKU of the pre-quote option chosen, when available. */
  capabilityKey?: string;
}

interface RequestState {
  draft: IRequestDraft | null;
  setDraft: (draft: IRequestDraft | null) => void;

  /** Result of the last successful mint, surfaced on the share screen. */
  mintResult: GenerateFundRequestLinkResult | null;
  setMintResult: (result: GenerateFundRequestLinkResult | null) => void;

  reset: () => void;
}

export const useRequestStore = create<RequestState>()(
  persist(
    (set) => ({
      draft: null,
      setDraft: (draft) => set(() => ({ draft })),
      mintResult: null,
      setMintResult: (mintResult) => set(() => ({ mintResult })),
      reset: () => set(() => ({ draft: null, mintResult: null })),
    }),
    { name: "raas-widgets-flow-request-draft" }
  )
);
